import { NgModule } from '@angular/core';
import { AppSharedModule } from '@gestor-web/app/shared/modules';
import { LongColumnHintComponent } from './long-column-hint.component';

@NgModule({
  declarations: [LongColumnHintComponent],
  exports: [LongColumnHintComponent],
  imports: [AppSharedModule],
})
export class LongColumnHintModule {}
